import React from 'react';
interface AppCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'compact' | 'normal' | 'large';
}
export function AppCard({
  children,
  className = '',
  hover = false,
  padding = 'normal'
}: AppCardProps) {
  const paddingClasses = {
    none: '',
    compact: 'p-4',
    normal: 'p-6',
    large: 'p-8'
  };
  return <div className={`
        bg-white dark:bg-dark-surface rounded-lg border border-gray-200/60 dark:border-dark-subtle
        ${hover ? 'hover:border-gray-300/60 dark:hover:border-dark-medium transition-all duration-180' : ''}
        ${paddingClasses[padding]}
        ${className}
      `} data-id="element-70">
      {children}
    </div>;
}